<template>
  <footer
    role="contentinfo"
    class="relative z-[1] shrink-0 overflow-hidden border-t border-stone-200/70 bg-gradient-to-b from-stone-50/98 to-stone-100/95 backdrop-blur-lg dark:border-white/[0.07] dark:from-[rgba(10,8,16,0.92)] dark:to-[rgba(5,4,10,0.96)]"
  >
    <div
      class="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-500/35 to-transparent dark:via-[rgba(242,216,150,0.22)]"
      aria-hidden="true"
    />
    <div
      class="relative mx-auto flex w-full max-w-6xl flex-col items-start gap-4 px-4 py-5 pb-[max(1.25rem,env(safe-area-inset-bottom))] min-[480px]:flex-row min-[480px]:items-center min-[480px]:justify-between min-[480px]:gap-6 min-[480px]:px-8 min-[480px]:py-4"
    >
      <p
        class="m-0 max-w-prose text-[0.8125rem] leading-snug text-stone-500 dark:text-stone-400"
      >
        {{ $t('footer.copyright', { year }) }}
      </p>

      
    </div>
  </footer>
</template>

<script setup lang="ts">
const year = new Date().getFullYear()
</script>
